import { QUESTION_BASE_TYPE } from '@/lib/schema/configuration/question_conditional';
import { AirtableFieldTypes } from '@/types/crm/airtable/fields';

export const AIRTABLE_FIELD_TYPES = [
    'singleLineText',
    'multilineText',
    'checkbox',
    'singleSelect',
    'multipleSelects',
    'number',
    'currency',
    'percent',
    'rating',
    'date',
    'dateTime',
    'duration_hours',
    'duration_days',
    'url',
    'email',
    'phoneNumber',
    'dateTimezone',
] as const;

export const airtableFieldTypesBaseTypes: Record<AirtableFieldTypes, typeof QUESTION_BASE_TYPE[number]> = {
    singleLineText: 'text',
    multilineText: 'text',
    checkbox: 'boolean',
    singleSelect: 'text',
    multipleSelects: 'list',
    number: 'number',
    currency: 'number',
    percent: 'number',
    rating: 'number',
    date: 'number',
    dateTime: 'number',
    duration_hours: 'number',
    duration_days: 'number',
    url: 'text',
    email: 'text',
    phoneNumber: 'text',
    dateTimezone: 'number',
}

